import styled from 'styled-components';
import {device} from '../../../styled/device';

export const BarLineContainer = styled.div`
  display: block;
  max-width: 295px;
  margin: 0 24px 32px;

  @media (min-width: ${device.mobileL}) {
    margin: 0 auto 45px;
    max-width: initial;
  }
`;

export const StepsText = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 24px;
  color: #152946;
  position: absolute;
  transform: translateY(-100%);
`;

export const SelectDocumentText = styled.div`
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  color: #152946;
  position: relative;
  img {
    position: absolute;
    left: -17px;
    top: 5px;
  }
  @media (min-width: ${device.tablet}) {
    font-size: 16px;
  }
`;

export const BarLine = styled.div`
  display: block;
  margin: 0 auto;
`;

export const StepperHeader = styled.div`
  display: flex;
  -webkit-box-pack: justify;
  justify-content: space-between;
`;

export const SkipText = styled.div`
  color: #393abd;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
`;
